import { NO_ERRORS_SCHEMA,NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgZorroModule } from './ng-zorro.module';

import { FormComponent } from './components/form/form.component';
import { HeaderComponent } from './components/header/header.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsAndConditionComponent } from './components/terms-and-condition/terms-and-condition.component';
import { AddressInputGoogleComponent } from './components/address-input-google/address-input-google.component';


@NgModule({
  declarations: [HeaderComponent, FormComponent, AboutUsComponent, ContactUsComponent, PrivacyPolicyComponent, TermsAndConditionComponent, AddressInputGoogleComponent ],
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    CommonModule,
    NgZorroModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    FormComponent,
    AboutUsComponent,
    ContactUsComponent,
    PrivacyPolicyComponent,
    TermsAndConditionComponent,
    AddressInputGoogleComponent,
      ],
   schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
